import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CacheService } from './services/cache.service';
import { CacheRunService } from './run/cache-run.service';

export function init_app (cacheRunService: CacheRunService) {
    return () => cacheRunService.initializeApp();
}

@NgModule({
    providers: [
        CacheService,
        provideAppInitializer(() => {
            const initializerFn = (init_app)(inject(CacheRunService));
            return initializerFn();
        }),
    ],
})
export class CacheModule {}
